export const DMN_PLANO = {
  BENEFICIO_DEFINIDO: "0001",
  CONTRIBUICAO_DEFINIDA: "0002"
};
